/**
 * LARGE CINEMATIC HERO
 */

VP = window.VP || {};

(function( $ ) {
	/**
	 * PRIVATE VARIABLES
	 */
	var SELECTOR = {
		sliderHero: '.js-slider-hero',
		heroContent: '.js-slider-hero__content',
		contentCarousel: '.js-slider-hero__article-carousel',
		contentSlide: '.js-slider-hero__article-slide',
		mediaCarousel: '.js-slider-hero__media-carousel',
		mediaSlide: '.js-slider-hero__media-slide',
		slideInfo: '.js-slider-hero__page',
		prevArrow: '.js-slider-hero__arrow--previous',
		nextArrow: '.js-slider-hero__arrow--next',
		//pagination: '.js-slider-hero__pagination',
		videoElement: '.vp-slider-hero__media--video',
		imageElement: '.vp-slider-hero__media--image'
	};
	var CLASSNAME = {
		spacer: 'vp-slider-hero__spacer',
		videoPlaying: 'vp-slider-hero__media--playing',
		fixed: 'vp-slider-hero--fixed',
	};
	// Default media carousel options,
	// extend this to include asNavFor, prevArrow, and nextArrow option as jQuery objects
	var MEDIA_CAROUSEL_OPTIONS = {
		infinite: false,
		slide: SELECTOR.mediaSlide,
		rows: 0
	};
	var CONTENT_CAROUSEL_OPTIONS = {
		infinite: false,
		fade: true,
		arrows: false,
		dots: false,
		adaptiveHeight: true
	};
	var SCROLL_EFFECT_SPEED = 1.25;
	// consider wrapper's negative offset
	var $wrapContainer = $( '.wrap.container' );
	// Create dummy element for spacer
	var $spacer = $( '<div>', { class: CLASSNAME.spacer } );

	/**
	 * CINEMATIC HERO CLASS
	 *
	 * @uses slick-carousel
	 */
	var SliderHero = function ( $element ) {
		// Just ensure we have a jQuery object here
		this.$element = $( $element );
		this.element = this.$element[0];

		this.$heroContent = $( SELECTOR.heroContent, this.$element );
		//this.$contentCarousel = $( SELECTOR.contentCarousel, this.$element );
		//this.$contentSlide = $( SELECTOR.contentSlide, this.$contentCarousel );
		this.$mediaCarousel = $( SELECTOR.mediaCarousel, this.$element );
		this.$mediaSlide = $( SELECTOR.mediaSlide, this.$mediaCarousel );
		this.$slideInfo = $( SELECTOR.slideInfo, this.$element );
		this.$prevArrow = $( SELECTOR.prevArrow, this.$element );
		this.$nextArrow = $( SELECTOR.nextArrow, this.$element );
		//this.$offSlidePagination = this.$heroContent.children(SELECTOR.pagination);
		this.$spacer = $spacer.clone();
		this.$immediateSibling = this.$element.next();

		var autoplayslides = (VP.helpers.getQParams("play") == 1) || !VP.helpers.isDev();
		var defaultspeed = 8000;
		var autoplayspeed =  isNaN(VP.helpers.getQParams("speed"))? defaultspeed : parseInt(VP.helpers.getQParams("speed") * 1000)
		if (isNaN(autoplayspeed) || autoplayspeed == 0) { autoplayspeed  = defaultspeed; }
		// console.log("[SliderHero] SPEED: " + autoplayspeed);


		this.mediaCarouselOptions = $.extend({}, MEDIA_CAROUSEL_OPTIONS, {
			prevArrow: this.$prevArrow,
			nextArrow: this.$nextArrow,
			dots: this.$mediaSlide.length > 1,
			autoplay: autoplayslides,
			autoplaySpeed: autoplayspeed,
			speed: 1000,
			infinite: true
			//asNavFor: this.$contentCarousel,
		});


		//this.contentCarouselOptions = $.extend({}, CONTENT_CAROUSEL_OPTIONS);

		this.addSpacer();
		this.bindCarousels();
		this.ieBgImage();


		this.$prevArrow.removeClass("fadewait").addClass("fadeshow");
		this.$nextArrow.removeClass("fadewait").addClass("fadeshow");


		$(".vp-slider-hero-text").addClass("loaded");
		// Attach instance data
		this.$element.data('largeSliderHero', this);

		this.$mediaCarousel.on("afterChange", function (){
			    // console.log("afterChange");
			});

	};

	SliderHero.prototype = $.extend({}, SliderHero.prototype, {
		addSpacer: function () {
			this.$element.before(this.$spacer);
		},

		bindCarousels: function () {
			var _this = this;

			// Bind carousels if slide length is >
			//if ( this.$contentSlide.length <= 1 ) { return this; }

			//this.contentCarouselOptions.adaptiveHeight = false; // VP.breakpoint.currentBreakpoint === 'small' ? true : false;

			//this.$contentCarousel.slick( this.contentCarouselOptions );
			this.$mediaCarousel.slick( this.mediaCarouselOptions );
			//this.bindPagination();
			this.bindMedia();
		},

/*		bindPagination: function () {
			var _this = this;

			_this.$mediaCarousel.on('beforeChange', function ( event, slick, previousIndex, nextIndex ) {
				_this.$slideInfo.text( nextIndex + 1 );
			});
		},*/

		bindMedia: function () {
			var _this = this;

			this.$mediaSlide.each(function ( index ) {
				// console.log("media slide");
				var $slide = $(this);
				var _mediaElement = $slide.children().get(0);
				var isVideoPlaying = false;
				var $video = $(_mediaElement);

				if ( !_mediaElement ) { return; }
				if ( _mediaElement.tagName !== 'VIDEO' ) { return; }

				$video.bind('play pause', function (e) {
					isVideoPlaying = 'play' === e.type ? true : false;
					$video.toggleClass( CLASSNAME.videoPlaying, isVideoPlaying );
				});


			_this.$mediaCarousel.on("beforeChange", function (){
			    // console.log("beforeChange");
			});

				// Bind video toggling on slide change // DOESN'T WORK??
				_this.$mediaCarousel.on('afterChange', function ( event, slick, currentIndex ) {
					// console.log("afterChange");

					if ( currentIndex === index && !isVideoPlaying ) {
						return _mediaElement.play();
					}
				});

				return _mediaElement.play();
			});
		},

		calculateMetrics: function () {
			this.height = this.$element.outerHeight();
		},

		// loads full-size background image for IE
		// fixes large hero image appearing zoomed in on IE.
		ieBgImage: function () {
			var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

			this.$mediaSlide.each(function ( index, ele  ) {
				var imgUrl = ele.dataset.bgImg;

				if (isIE11) {
					$(ele).css({
						'background-image': 'url('+ imgUrl +')',
						'opacity': 1
					});
				}
			});
		},



	});

	/**
	 * CINEMATIC HERO MODULE ATTACHED TO APP
	 */
	VP.featuredHeroSlider = {
		$elements: $(SELECTOR.sliderHero),
		instances: [],

		init: function () {
			var _this = this;

			_this.$elements.each(function () {
				_this.instances.push(new SliderHero(this));
			});

			_this.setBodyHeroType();
			_this.autoPlay();
			_this.setHeroFadeIn();

			VP.documentEvents.onResize( this.onResize.bind( this ), true );
			this.onResize();
		},

		setBodyHeroType: function() {
			var heroType = this.$elements.attr('data-slider-hero-type');

			$('body').addClass('vp-slider-hero-' + heroType);

			if ( 'small' === heroType ) {
			//	$('.vp-header').addClass( 'vp-header--docked' );
			}
		},

		autoPlay: function () {
			if( $( 'video' ).hasClass( 'vp-slider-hero__media--video' ) ) {
				$( SELECTOR.videoElement ).addClass( 'is-visible' );
			}
		},

		setHeroFadeIn: function() {
			var lazyloadCheck = setInterval(function(){
				if ( $( SELECTOR.imageElement ).hasClass('lazyloaded') )  {
					$( SELECTOR.heroContent ).addClass('vp-slider-hero__content-load-complete');
					clearInterval( lazyloadCheck );
				}
			}, 300);
		},
		onResize: function () {
			var _this = this;
			var $hero = $(".js-slider-hero[data-slider-hero-type='large']");
			if ($hero.length > 0) {
				var winheight = $( window ).height();
				var bp = VP.breakpoint.currentBreakpoint;
				if (bp == 'large' || bp == 'xlarge') {
					$hero.height("auto");
					if ($hero.height() > winheight) {
						$hero.height(winheight);
					}
				}
				else {
					$hero.height('');
				}
			}

		},


		onScroll: function () {

		}
	};
})(jQuery);
